import { useScopedI18n } from "@/messages/client";
import { useCallback } from "react";

export function useCodeMessage() {
  const t = useScopedI18n("responseError")
  return useCallback((code: string, message?: string) => {
    // @ts-ignore
    const content =  t(code) 
    console.log('t', content)
    if (content?.indexOf(code.toString()) === -1) {
      return content
    }
    return message ?? code
  }, [t])
}
